import { http } from '@/core/helpers/axiosHelper';

export class PermissionService {
   async getPermissionModelScopes(resource_type: string, requires_id: 0 | 1) {
      const response = await http.get(import.meta.env.VITE_APP_API_BASE_URL_DATA + '/permission/model/scopes', {
         params: { resource_type, requires_id },
      });

      return response.data;
   }

   async postBulk(body: Object) {
      return await http.post('/permission/bulk', body).then((response) => {
         return response.data;
      });
   }
}
